"use strict";
/* eslint-disable react/prop-types */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SearchModuleDefinition = exports.SearchInput = void 0;
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var SearchInput = function (_a) {
    var slim = _a.slim, expandingOrCollapsing = _a.expandingOrCollapsing, searchUrl = _a.searchUrl, strings = _a.strings, navigate = _a.navigate;
    var isVisible = !slim || expandingOrCollapsing;
    var onSubmitForm = function (e) {
        if (e.target instanceof HTMLFormElement) {
            e.preventDefault();
            if (isVisible) {
                var inputElement = e.target.querySelector('input[name="q"]');
                navigate(searchUrl + '?q=' + encodeURIComponent(inputElement.value));
            }
            else {
                navigate(searchUrl);
            }
        }
    };
    var className = ('sidebar-search'
        + (slim ? ' sidebar-search--slim' : '')
        + (isVisible ? ' sidebar-search--visible' : ''));
    return (React.createElement("form", { role: "search", className: className, action: searchUrl, method: "get", onSubmit: onSubmitForm },
        React.createElement("label", { className: "sidebar-search__label", htmlFor: "menu-search-q" }, strings.SEARCH),
        React.createElement("input", { className: "sidebar-search__input", type: "text", id: "menu-search-q", name: "q", placeholder: strings.SEARCH }),
        React.createElement("button", { className: "button sidebar-search__submit", type: "submit", "aria-label": strings.SEARCH },
            React.createElement(Icon_1["default"], { className: "icon--menuitem", name: "search" }))));
};
exports.SearchInput = SearchInput;
var SearchModuleDefinition = /** @class */ (function () {
    function SearchModuleDefinition(searchUrl) {
        this.searchUrl = searchUrl;
    }
    SearchModuleDefinition.prototype.render = function (_a) {
        var slim = _a.slim, key = _a.key, expandingOrCollapsing = _a.expandingOrCollapsing, strings = _a.strings, navigate = _a.navigate;
        return (React.createElement(exports.SearchInput, { searchUrl: this.searchUrl, slim: slim, key: key, expandingOrCollapsing: expandingOrCollapsing, strings: strings, navigate: navigate }));
    };
    return SearchModuleDefinition;
}());
exports.SearchModuleDefinition = SearchModuleDefinition;
